import axios from 'axios';
import { axiosInstance } from '../Axios';
const { createSlice } = require('@reduxjs/toolkit');

const PackageReducers = createSlice({
	name: 'Package',
	initialState: {
		success: false,
		error: null,
		loadingPackage: false,
		packageresult: null,
		locationresult: null,
		enquiry: null,
		addpackageresult: null,
	},
	reducers: {
		packageRequest(state, action) {
			state.loadingPackage = true;
		},
		packageSuccess(state, action) {
			state.loadingPackage = false;
			state.packageresult = action.payload;
			state.error = null;
		},
		packageFail(state, action) {
			state.loadingPackage = false;
			state.error = action.payload;
		},
		locationRequest(state, action) {
			state.loadingPackage = true;
		},
		locationSuccess(state, action) {
			state.loadingPackage = false;
			state.locationresult = action.payload;
			state.error = null;
		},
		locationFail(state, action) {
			state.loadingPackage = false;
			state.error = action.payload;
		},
		enquiryRequest(state, action) {
			state.loadingPackage = true;
		},
		enquirySuccess(state, action) {
			state.loadingPackage = false;
			state.enquiry = action.payload;
			state.error = null;
		},
		enquiryFail(state, action) {
			state.loadingPackage = false;
			state.error = action.payload;
		},
		addpackageRequest(state, action) {
			state.loadingPackage = true;
		},
		addpackageSuccess(state, action) {
			state.loadingPackage = false;
			state.addpackageresult = action.payload;
			state.error = null;
		},
		addpackageFail(state, action) {
			state.loadingPackage = false;
			state.error = action.payload;
		},
	},
});
const config = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjO4lqe3PG9musafi==',
	},
};
const { actions } = PackageReducers;

export const {
	packageRequest,
	packageSuccess,
	packageFail,
	locationRequest,
	locationSuccess,
	locationFail,
	enquiryRequest,
	enquirySuccess,
	enquiryFail,
	addpackageRequest,
	addpackageSuccess,
	addpackageFail,
} = actions;

export const fetchAllPackageDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(packageRequest());
		const { data } = await axios.post(
			'https://newinv.musafirbazar.com/apiC/package',
			bodyData,
			config
		);

		dispatch(packageSuccess(data));
	} catch (error) {
		dispatch(
			packageFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const fetchAllLocationDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(locationRequest());
		const { data } = await axios.post(
			'https://newinv.musafirbazar.com/apiC/package/location',
			bodyData,
			config
		);

		dispatch(locationSuccess(data));
	} catch (error) {
		dispatch(
			locationFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export default PackageReducers;
